var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$style.screen,
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.$emit("screen-click")
        }
      }
    },
    [
      _c("div", { staticClass: "ui container", class: _vm.$style.buttons }, [
        _c(
          "div",
          { class: _vm.$style.contentWidth },
          [
            _c("search-type-buttons", {
              attrs: { type: _vm.type, "in-screen": true },
              on: { change: _vm.changeType }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }